import * as Updater from './updater';
export default Updater;
